var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-notificator-wrapper",on:{"click":_vm.irParaAvisosInbox}},[_c('font-awesome-icon',{staticClass:"envelope-icon",attrs:{"icon":"envelope","size":"2x"}}),_c('b-badge',{staticClass:"align-top custom-badge",attrs:{"variant":"success","pill":""}},[_vm._v(_vm._s(_vm.unreadCount))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }